import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/InventoryIssueStatusReport/Filter'

export default createListViewComponent({
  entityName: entityNames.inventoryIssueStatusReport,
  filterTemplateType: 'InventoryIssueStatusReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowDelete: (self) => false,
  allowSelection: (self) => false,
})(Filter)
